export class Card {
  id: number;
  part: string[] = [];
  card: string;
  verified: 'PENDING' | 'ACCEPTED' | 'REJECTED';
  loading = false;
  errors: any = {};

  constructor(input: any = {}) {
    this.id = input.id;
    this.card = input.card;
    if (this.card) {
      this.part = this.card.match(/.{1,4}/g)?.map((each) => each) ?? [];
    }
    this.verified = input.verified;
  }
}
